import { getValidDomain } from '../../../shared-functions/DomiansplitFunction';
import getToken from '../../helpers';

/**
 *
 * Default headers for auth
 * @returns
 */
const defaultHeaders = () => {
  const accessToken = getToken();
  const headers: HeadersInit = {};
  if (accessToken) {
    headers.Authorization = accessToken;
    headers['Guest-Token'] = accessToken;
  }
  const domain = getValidDomain();
  if (domain) {
    headers.domain = domain;
  }

  return Object.keys(headers).length > 0 ? headers : null;
};

export default defaultHeaders;
